import React from "react";

const YoutubeSVG = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.812 5.51711H6.145C3.855 5.51711 2 7.35211 2 9.61611V15.3841C2 17.6481 3.856 19.4841 6.145 19.4841H17.812C20.102 19.4841 21.957 17.6481 21.957 15.3841V9.61611C21.957 7.35211 20.101 5.51611 17.812 5.51611V5.51711ZM15.009 12.7801L9.552 15.3551C9.51872 15.3711 9.48192 15.3785 9.44503 15.3765C9.40815 15.3744 9.37237 15.3631 9.34103 15.3436C9.3097 15.324 9.28382 15.2968 9.2658 15.2646C9.24779 15.2323 9.23822 15.1961 9.238 15.1591V9.85011C9.23867 9.81299 9.24872 9.77663 9.26722 9.74444C9.28573 9.71224 9.31208 9.68526 9.34382 9.66599C9.37556 9.64673 9.41167 9.63581 9.44877 9.63425C9.48587 9.6327 9.52276 9.64057 9.556 9.65711L15.014 12.3921C15.0504 12.4102 15.0809 12.4383 15.102 12.4729C15.1232 12.5076 15.1341 12.5476 15.1336 12.5882C15.1331 12.6288 15.1211 12.6685 15.0991 12.7026C15.077 12.7367 15.0458 12.7639 15.009 12.7811V12.7801Z"
        fill="#0F172A"
      />
    </svg>
  );
};

export default YoutubeSVG;
